/* eslint-disable @bigbinary/neeto/use-neetoui-classes */
import classNames from "classnames";
import { Moon, Sun } from "lucide-react";
import useLocalStorage from "neetocommons/react-utils/useLocalStorage";
import { useTranslation } from "react-i18next";

import { APP_THEME_LOCALSTORAGE_KEY, THEMES } from "../../constants";
import { setDarkTheme, setLightTheme } from "../../utils";

const ThemeSwitcher = () => {
  const { t } = useTranslation();

  const [appTheme, setAppTheme] = useLocalStorage(
    APP_THEME_LOCALSTORAGE_KEY,
    THEMES.LIGHT
  );
  const isDarkThemeSelected = appTheme === THEMES.DARK;

  const switchTheme = theme => {
    theme === THEMES.LIGHT ? setLightTheme() : setDarkTheme();
    setAppTheme(theme);
  };

  return (
    <div className="bg-muted/40 flex items-center justify-between gap-3 rounded-b-xl px-4 py-3">
      <span className="text-muted-foreground text-xs font-medium">
        {t("neetoMolecules.sidebar.themeSwitcher.label")}
      </span>
      <div
        className="bg-muted flex rounded-lg p-0.5"
        data-testid="theme-switcher-button"
      >
        <button
          data-testid="theme-switcher-light-button"
          type="button"
          className={classNames(
            "flex items-center gap-1 rounded-md px-2.5 py-1.5 text-xs font-medium transition-all",
            isDarkThemeSelected
              ? "text-muted-foreground hover:text-foreground"
              : "bg-background text-foreground ring-border shadow-sm ring-1"
          )}
          onClick={() => switchTheme(THEMES.LIGHT)}
        >
          <Sun size={13} />
          {t("neetoMolecules.sidebar.themeSwitcher.light")}
        </button>
        <button
          data-testid="theme-switcher-dark-button"
          type="button"
          className={classNames(
            "flex items-center gap-1 rounded-md px-2.5 py-1.5 text-xs font-medium transition-all",
            isDarkThemeSelected
              ? "bg-background text-foreground ring-border shadow-sm ring-1"
              : "text-muted-foreground hover:text-foreground"
          )}
          onClick={() => switchTheme(THEMES.DARK)}
        >
          <Moon size={13} />
          {t("neetoMolecules.sidebar.themeSwitcher.dark")}
        </button>
      </div>
    </div>
  );
};

export default ThemeSwitcher;
